// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"NavItem_dropdown__6_OEL","navItem":"NavItem_navItem__MJ6VB"};